import { createContext } from "react";

const RoutesContext = createContext();

export default RoutesContext;
